import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Carousel from '../../../../../../layouts/carousel';
import { useBackgroundImageWithFallback } from '../../../../../../../hooks/useBackgroundImageWithFallback';
import classnames from 'classnames/bind';
import styles from './index.scss';
const cx = classnames.bind(styles);
const VerifiedImage = ({ url, featureFlags }) => {
    const verifiedUrl = useBackgroundImageWithFallback(url, featureFlags['fe.resi.enabled-photo-enhancement']);
    return (_jsx("div", { className: cx('image'), style: { backgroundImage: `url('${verifiedUrl}')` } }));
};
VerifiedImage.propTypes = {
    url: PropTypes.string.isRequired,
    featureFlags: PropTypes.object.isRequired,
};
const ImageCarousel = ({ className, images, featureFlags, ...props }) => (_jsx(Carousel, { ...props, className: cx('root', className), children: images.map(url => (_jsx("div", { children: _jsx(VerifiedImage, { url: url, featureFlags: featureFlags }) }, url))) }));
ImageCarousel.propTypes = {
    images: PropTypes.arrayOf(PropTypes.string).isRequired,
    className: PropTypes.string,
    featureFlags: PropTypes.object,
    carouselRef: PropTypes.object,
};
export default ImageCarousel;
//# sourceMappingURL=index.js.map